export default __webpack_public_path__ + "static/media/diary.c223a2f2.svg";